import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateProviderPaymentAttachmentDownloadPresignedUrl = async (fileKey: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: { fileKey },
    query: graphql(`
      query generateProviderPaymentAttachmentDownloadPresignedUrl($fileKey: String!) {
        generateProviderPaymentAttachmentDownloadPresignedUrl(fileKey: $fileKey)
      }
    `),
  });

  return response.data.generateProviderPaymentAttachmentDownloadPresignedUrl;
};
